export enum CookieConsentCategory {
    Necessary = 'NECESSARY',
    Functional = 'FUNCTIONAL',
    Analytical = 'ANALYTICAL',
    Targeting = 'TARGETING',
}
